import { render, staticRenderFns } from "./CompareEventsDialog.vue?vue&type=template&id=1bb68e1e&scoped=true"
import script from "./CompareEventsDialog.vue?vue&type=script&lang=js"
export * from "./CompareEventsDialog.vue?vue&type=script&lang=js"
import style0 from "./CompareEventsDialog.vue?vue&type=style&index=0&id=1bb68e1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb68e1e",
  null
  
)

export default component.exports